import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import TextField from '../common/Input';
import Button from '../common/Button';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormValidator from '../../utils/validator';
import { toast } from 'react-toastify';
import { tagadd, tagGet } from '../../actions/tags';
import { useEffect } from 'react';

const AddTag = (props) => {
  const { classes } = props;
  const [errors, setErrors] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [tag, setTag] = useState({
    tagName: ""
  })
  const schema = [
    {
      field: 'tagName',
      method: ['isEmpty'],
      validWhen: false,
      message: 'Tag name is required.',
    },
  ];



  const validator = new FormValidator(schema);
  const handleChange = (key, e) => {
    setTag({
      ...tag,
      [key]: e.target.value
    })
  }
  const addTag = () => {
    const err = validator.validate({ ...tag });
    setErrors(err);
    if (!err.isValid) {
      return;
    }
    setLoading(true);
    tagadd(tag, (message, isError) => {
      const method = isError ? 'error' : 'success';
      let newMessage = method ==="success" ? "Tag successfully added" : "Somthing goes wrong";
      toast[method](newMessage);
      // toast[method](newMessage);
      setLoading(false);
      setTag({ tagName: "" });
    })
  };
  // , () => tagGet()

  return (<div>
    <Card className={classes.root}>
      <CardHeader subheader="Add Tag" classes={{ subheader: classes.header }} />
      <CardContent>
        <TextField
          label="Tag Name"
          name="tagName"
          placeholder="Add Tag name"
          onChange={(e) => handleChange('tagName', e)}
          classes={{ root: classes.input }}
          value={tag.tagName}
          error={errors && errors.tagName && errors.tagName.isInvalid}
          helperText={errors && errors.tagName && errors.tagName.isInvalid && errors.tagName.message}
        />
        <Button size="small" label="Add" onClick={addTag}></Button>
      </CardContent>
    </Card>
  </div>)
}


export default AddTag;
